import React, { useEffect, useRef } from "react";
import { drawEgg } from "../golden-eggs";
import styles from "./EggBalanceChip.module.scss";

// The player's egg balance as a pill: a small live egg + the number. In the
// modal's header on PC, the same place in the shop and on your profile.
// (data-eggchip: the shop's buy and spend celebrations and the profile's
// opened achievements fly their eggs to it.)
export default function EggBalanceChip({ value }: { value: number }) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  useEffect(() => {
    const ctx = canvasRef.current?.getContext("2d");
    if (!ctx) return;
    let running = true;
    const start = performance.now();
    function loop(now: number) {
      if (!running || !ctx) return;
      ctx.clearRect(0, 0, 44, 44);
      drawEgg(ctx, 44, (now - start) / 1000);
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    return () => { running = false; };
  }, []);
  return (
    <span className={styles.balance} title="Your Golden Eggs" data-eggchip="">
      <canvas ref={canvasRef} width={44} height={44} />
      {value.toLocaleString()}
    </span>
  );
}
